"use client";

import React, { useState, useEffect } from 'react';

export default function FeedbackWidget() {
    const [isOpen, setIsOpen] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [rating, setRating] = useState(null);
    const [feedbackText, setFeedbackText] = useState("");

    // Track scroll to show button only when reaching the specific section
    useEffect(() => {
        const handleScroll = () => {
            const triggerElement = document.getElementById('feedback-trigger');
            if (triggerElement) {
                const rect = triggerElement.getBoundingClientRect();
                // Show when the trigger element scrolls into the viewport
                if (rect.top <= window.innerHeight) {
                    setIsVisible(true);
                } else {
                    setIsVisible(false);
                    setIsOpen(false); // Optionally close if they scroll all the way back up
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll(); // Initial check on mount

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            {/* 1. Fixed Button on the Left */}
            <div
                className={`fixed left-0 top-[60%] -translate-y-1/2 z-40 transition-all duration-500 ease-in-out ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-full'
                    }`}
            >
                <button
                    onClick={() => setIsOpen(true)}
                    className="bg-black text-white py-4 px-2 rounded-lg flex items-center justify-center hover:bg-gray-800 transition-colors"
                    style={{ writingMode: 'vertical-rl', transform: 'rotate(180deg)' }}
                >
                    <span className="font-bold text-sm tracking-widest whitespace-nowrap">دیدگاه شما</span>
                </button>
            </div>

            {/* 2. Modal Overlay (Darkens background) */}
            <div
                className={`fixed inset-0 bg-black/60 z-[60] backdrop-blur-sm transition-opacity duration-300 ${isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
                    }`}
                onClick={() => setIsOpen(false)}
            />

            {/* 3. Sliding Modal Panel (From Left) */}
            <div
                dir="rtl"
                className={`fixed top-0 left-0 h-full w-full sm:w-[450px] bg-white z-[70] shadow-2xl flex flex-col p-6 sm:p-8 transform transition-transform duration-500 ease-in-out ${isOpen ? 'translate-x-0' : '-translate-x-full'
                    }`}
            >
                {/* Header & Close Button */}
                <div className="flex justify-between items-center mb-8">
                    <h2 className="text-3xl font-bold text-gray-900">دیدگاه شما</h2>
                    <button
                        onClick={() => setIsOpen(false)}
                        className="text-gray-500 hover:text-black transition-colors"
                        aria-label="Close"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-6 h-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                {/* Rating Section */}
                <div className="mb-8">
                    <p className="text-gray-900 font-medium mb-4">اطلاعات این صفحه چقدر برای شما مفید بود؟</p>
                    <div className="flex justify-between gap-2 mb-2">
                        {[1, 2, 3, 4, 5].map((num) => (
                            <button
                                key={num}
                                onClick={() => setRating(num)}
                                className={`w-full py-3 rounded-lg border transition-colors ${rating === num
                                    ? 'border-black bg-black text-white'
                                    : 'border-gray-300 bg-gray-50 text-gray-700 hover:border-gray-400'
                                    }`}
                            >
                                {num}
                            </button>
                        ))}
                    </div>
                    <div className="flex justify-between text-sm text-gray-500">
                        <span>اصلا مفید نبود</span>
                        <span>بسیار مفید بود</span>
                    </div>
                </div>

                {/* Textarea Section */}
                <div className="mb-6 flex-grow">
                    <p className="text-gray-900 font-medium mb-4">چگونه می‌توانیم این صفحه را برای شما بهبود دهیم؟</p>
                    <div className="relative h-[200px]">
                        <textarea
                            value={feedbackText}
                            onChange={(e) => setFeedbackText(e.target.value)}
                            className="w-full h-full p-4 bg-gray-50 border border-gray-300 rounded-lg resize-none focus:outline-none focus:ring-1 focus:ring-black focus:border-black"
                            placeholder="دیدگاه خود را اینجا بنویسید..."
                        />
                        <span className="absolute bottom-4 left-4 text-xs text-gray-400">
                            {feedbackText.length}
                        </span>
                    </div>
                </div>

                {/* Submit Button */}
                <button
                    disabled={!rating}
                    className={`w-auto mr-auto px-8 py-3 rounded-lg font-bold transition-colors ${rating
                        ? 'bg-black text-white hover:bg-gray-800'
                        : 'bg-[#9b9b9b] text-white/80 cursor-not-allowed'
                        }`}
                >
                    ارسال دیدگاه
                </button>
            </div>
        </>
    );
}